import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, SubmitInput, Error, Success, Select } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

const CreatePromo: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleYesClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    const target = e.target as typeof e.target & {
      extensionType: { value: string };
      date: { value: string };
      promotionName: { value: string };
      maxRedemption: { value: number };
    };
    
    const extensionType = target.extensionType.value;
    const date = target.date.value;
    const promotionName = target.promotionName.value;
    const maxRedemption: number = +target.maxRedemption.value;
    
    if (isNaN(maxRedemption)) {
      alert('Please provide a proper integer as the value for Max Redemptions');
      return;
    }
    
    const validUntil = new Date(date).getTime();

    if (!extensionType || !validUntil || !promotionName || !maxRedemption) {
      alert('Invalid input for promo codes');
      return;
    }

    setIsLoading(true);

    try {
      const result = await callFunction('referralsAndPromoCodes/generatePromoCode', {
        extensionType,
        promotionName,
        maxRedemption,
        validUntil
      });
      
      setSuccess(`Successfully created code/s:\n${JSON.stringify(result, null, 2)}`);
    } catch (error: any) {
      console.error('Failed to generate promo code:', error);
      setError(error?.message || error?.error || 'Failed to generate promo code');
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleNoClick = () => {};

  const handleAlert = (e: React.SyntheticEvent) => {
    const confirmed = window.confirm('Are you sure you want to create codes?');
    if (confirmed) {
      handleYesClick(e);
    } else {
      handleNoClick();
    }
  };
  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleAlert}>
      <label htmlFor="extensionType">Type of the promotion extension</label>
      <Select id="extensionSelector" name="extensionType">
        <option value="WEEKLY">Weekly</option>
        <option value="MONTHLY">Monthly</option>
        <option value="ANNUALLY">Annually</option>
      </Select>
      <label htmlFor="date">Valid until date</label>
      <Input placeholder="Valid until date" type="date" name="date" />
      <label htmlFor="promotionName">Name of the promotion code :</label>
      <Input placeholder="Promo Name" name="promotionName" />
      <label htmlFor="maxRedemption">Maximum number of people this promotion is valid for :</label>
      <Input placeholder="Maximum number of people who can redeem" name="maxRedemption" />
      <SubmitInput type="submit" value={isLoading ? "Generating..." : "Generate"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
      </Form>
    </>
  );
};

export { CreatePromo };
